const attributes = {
  slider: "data-slider",
  slideItem: "data-horizontal-slider-slide",
  dotsContainer: "data-horizontal-slider-dots",
};

class HorizontalSlider extends HTMLElement {
  constructor() {
    super();

    this.$slider = this.querySelector(`[${attributes.slider}]`);
    this.$slides = Array.from(
      this.querySelectorAll(`[${attributes.slideItem}]`)
    );
    this.$dotsContainer = this.querySelector(`[${attributes.dotsContainer}]`);
    this.createDots();
  }

  createDots() {
    this.$slides.forEach((_slide, index) => {
      const dot = document.createElement("button");
      dot.classList.add("icons-row__slider-dot");
      if (index === 0) dot.classList.add("active");

      dot.addEventListener("click", () => {
        this.$slider.scrollTo({
          left: this.$slides[index].offsetLeft,
          behavior: "smooth",
        });
      });

      this.$dotsContainer.appendChild(dot);
    });

    const dots = Array.from(
      this.$dotsContainer.querySelectorAll(".icons-row__slider-dot")
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = this.$slides.indexOf(entry.target);
            if (index !== -1) {
              dots.forEach((dot) => dot.classList.remove("active"));
              dots[index].classList.add("active");
            }
          }
        });
      },
      {
        root: this.$slider,
        threshold: 0.6,
      }
    );

    this.$slides.forEach((slide) => observer.observe(slide));
  }
}

customElements.define("horizontal-slider", HorizontalSlider);